import { connectSortBy } from 'instantsearch.js/es/connectors'
import { get } from '@bigyouth/base'

let sortByInit = false

const renderSortBy = (renderOptions, isFirstRender) => {
  const {
    options,
    currentRefinement,
    refine,
    widgetParams,
  } = renderOptions

  const urlParams = new URLSearchParams(window.location.search)
  const themeInUrl = urlParams.get('theme')

  if (!isFirstRender && !sortByInit) {
    if (sessionStorage.getItem('sort') && sessionStorage.getItem('prevUrl').includes('/formations/')) {
      if (!themeInUrl) {
        refine(sessionStorage.getItem('sort'))
        get(`[js-algolia-list-sort2] [data-value="${sessionStorage.getItem('sort')}"]`).classList.add('is-active')
      }

      sessionStorage.removeItem('sort')
    }

    sortByInit = true
  }

  if (isFirstRender) {
    const ul = document.createElement('ul')

    widgetParams.container.appendChild(ul)

    ul.innerHTML = `
      ${options.map(option => `
        <li>
          <button data-value="${option.value}" class="${option.value === currentRefinement ? 'is-active' : ''}">${option.label}</button>
        </li>`).join('')}`

    ul.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', (e) => {
        refine(e.target.dataset.value)
      })
    })
  }
}

const customSortBy2 = connectSortBy(renderSortBy)

export default customSortBy2
